import React, { useState, useEffect, useContext } from "react";
import AuthContext from "../../Context/AuthContext";
import PersonOverviewDashboard from "../Components/PersonOverviewDashboard";
import PersonDocuments from "../Components/PersonDocuments";
import { useParams, useLocation } from "react-router-dom";
import axios from "axios";
import Spinner from "react-bootstrap/Spinner";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import { useTranslation } from "react-i18next";
import "./PersonOverview.css";

function PersonOverview() {
  const [isLoading, setIsLoading] = useState(true);
  const [personData, setPersonData] = useState({});
  const [talentData, setTalentData] = useState([]);
  const [performanceData, setPerformanceData] = useState([]);
  const [strenghts, setStrenghts] = useState([]);
  const [weaknesses, setWeaknesses] = useState([]);
  const [key, setKey] = useState("datosGenerales");
  const [documents, setDocuments] = useState([]);

  const { state } = useContext(AuthContext);

  const { pid } = useParams();

  const location = useLocation();

  const { t } = useTranslation();

  const tabKey = location.state?.tabKey;

  useEffect(() => {
    async function fetch() {
      const response = await axios({
        method: "post",
        url: `${process.env.REACT_APP_BACKEND_URL}/reports/people/overview/${pid}`,
        headers: {
          Authorization: `Bearer ${state.token}`,
        },
      });

      const result = await axios({
        method: "get",
        url: `${process.env.REACT_APP_BACKEND_URL}/users/people/documents/${pid}`,
        headers: {
          Authorization: `Bearer ${state.token}`,
        },
      });
      setPersonData(response.data.userData);
      setStrenghts(response.data.strenghts);
      setWeaknesses(response.data.weaknesses);
      setTalentData(response.data.talentData);
      setPerformanceData(response.data.performanceData);
      setDocuments(result.data.documents);
      setIsLoading(false);
      setKey(tabKey);
    }
    fetch();
  }, []);

  const handleSubmitDocument = async (e) => {
    const formData = new FormData();
    formData.append(e.target.name, e.target.files[0]);

    const response = await axios({
      method: "post",
      url: `${process.env.REACT_APP_BACKEND_URL}/reports/people/overview/${pid}`,
      data: formData,
      headers: {
        Authorization: `Bearer ${state.token}`,
      },
    });
    setPersonData(response.data.userData);
    setStrenghts(response.data.strenghts);
    setWeaknesses(response.data.weaknesses);
    setTalentData(response.data.talentData);
    setPerformanceData(response.data.performanceData);
    setDocuments(response.data.documents);
  };

  const handleDownloadDocument = async (key) => {
    const response = await axios({
      method: "post",
      url: `${process.env.REACT_APP_BACKEND_URL}/users/people/download/document/${pid}`,
      data: { key: key },
      headers: {
        Authorization: `Bearer ${state.token}`,
      },
    });

    const link = document.createElement("a");
    link.download = key;

    link.target = "_blank";

    link.href = response.data.url;

    link.click();
  };

  if (isLoading === true) {
    return (
      <Spinner animation="border" role="status">
        <span className="visually-hidden">Loading...</span>
      </Spinner>
    );
  } else {
    return (
      <Tabs
        id="controlled-tab-example"
        activeKey={key}
        onSelect={(k) => {
          setKey(k);
        }}
        className="mb-3"
      >
        <Tab
          eventKey="datosGenerales"
          title={t("Personas.Persona.Overview.DatosGenerales")}
        >
          <PersonOverviewDashboard
            generalData={personData}
            strenghts={strenghts}
            weaknesses={weaknesses}
            talentAssessments={talentData}
            performanceAssessments={performanceData}
            language={state.language}
          />
        </Tab>
        <Tab
          eventKey="documentos"
          title={t("Personas.Persona.Overview.Documentos")}
        >
          <PersonDocuments
            documents={documents}
            handleSubmitDocument={handleSubmitDocument}
            handleDownloadDocument={handleDownloadDocument}
            id={pid}
            language={state.language}
          />
        </Tab>
      </Tabs>
    );
  }
}

export default PersonOverview;
